import { Component, Inject, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PDFExportComponent } from '@progress/kendo-angular-pdf-export';
import { SettingsService } from 'app/services/core/settings.service';
import { SearchLabsService } from 'app/services/searchLabs/searchLabs.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedService } from 'app/services/core/shared.service';
import { ICertificateReportMatrixViewModel, ICertificateReportViewModel, IFoaReportViewModel } from 'app/models/report/reports';
import { drawDOM, exportPDF } from '@progress/kendo-drawing';
import { CertificateService } from 'app/services/lab-user-menu/certificate.service';
import { CertificateReportComponent } from '../certificateReport/certificateReport.component';

@Component({
  selector: 'attachedReportHeader',
  templateUrl: './attachedReportHeader.component.html',
  // styleUrls: ['./attachedReportHeader.component.scss']
})

export class AttachedReportHeaderComponent {
  
  @ViewChild('pdf') pdf: PDFExportComponent;
  public certData: ICertificateReportViewModel = {} as ICertificateReportViewModel;
  public matrixData: ICertificateReportMatrixViewModel[] = [];
  public uniqueAnalyteNames: string[] = [];
  public certId: number = 0;
  public certList: { matrix: string, foaList: { method: string, foas: IFoaReportViewModel[] }[] }[] = [];
  private file: File = null;

  constructor(public searchLabsService: SearchLabsService,  
    public settings: SettingsService,
    private dialogRef: MatDialogRef<AttachedReportHeaderComponent>,
    private sharedService: SharedService,
    private certificateService: CertificateService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log('certificate report for application', this.sharedService.currentApplication);
    this.certData = this.data.certData;
    this.certId = this.data.certId;
    this.matrixData = this.data.certData.analytes || [];
    this.certificateList(this.matrixData);
  }

  certificateList(cert: ICertificateReportMatrixViewModel[]): void {
    // Get unique analyte names
    const names = cert.map(analyte => analyte.name);
    this.uniqueAnalyteNames = [...new Set(names)];
    console.log('unique analyte names', this.uniqueAnalyteNames);
  }

  getAnalytesByMatrix(analyteName: string, matrix: string): string {
    const analytes = this.matrixData.filter(a => a.name === analyteName && a.matrix === matrix);
    return analytes.length > 0 ? analyteName : '';
  }

  ngOnInit(): void {
  }

  printReport(): void {
    if (this.pdf) {
      this.pdf.saveAs('ORELAP_Certificate_Report.pdf');
      this.savePdfToDatabase();
    }
  }

  savePdfToDatabase(): void {
    const element = document.querySelector('.report-content');
    if (!element) {
      console.error('PDF content element not found');
      return;
    }

    // drawDOM(element as HTMLElement, {
    //   paperSize: 'auto',
    //   margin: { top: '0cm', right: '0cm', bottom: '0cm', left: '0cm' }
    // }).then((group) => {
    //   return exportPDF(group);
    // })
    this.pdf.export().then((group) => {
      return exportPDF(group);
    }).then((dataUri) => {
      // Convert data URI to Blob
      const byteString = atob(dataUri.split(',')[1]);
      const mimeString = dataUri.split(',')[0].split(':')[1].split(';')[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      const blob = new Blob([ab], { type: mimeString });
      const fileName: string = `ORELAP_Certificate_Report.pdf`;

      // this.downloadFile(`ORELAP_Certificate_ReportXXX.pdf`, blob);
      const formData = new FormData();
      // Save to database
      
      formData.append('file', blob, fileName);
      this.certificateService.savePrintedCertificate(
        this.certId,
        formData
      ).subscribe(
        response => {
          alert('PDF saved to database successfully');
        },
        error => {
          alert('Error saving PDF to database: ' + error.message);
        }
      );
    }).catch((error) => {
      alert('Error generating PDF ' + error.message);
    });
  }

  downloadFile(fileName: string, blob: Blob) {
    let file = URL.createObjectURL(blob);
    var fileDownload = document.createElement('a');
    fileDownload.href = file;
    fileDownload.download = fileName;
    fileDownload.click();
  }

  // onFileSelected(event): void {
  //   let newFiles: File[] = Array.from(event.target.files);
  //   newFiles.forEach(file => {
  //     this.files.push(file);
  //     this.fileNames.push(file.name);
  //   });
  // }

  // uploadFiles(): void {
  //   if (this.files.length > 0) {
  //     const formData = new FormData();
  //     this.files.map((file, index) => {
  //       return formData.append('file' + index, file, file.name);
  //     });
  //     this.submitApplicationService.uploadDocuments(formData, this.sharedService.currentApplication.labApplicationId).subscribe(
  //       () => {
  //         this.files = [];
  //         this.fileNames = [];
  //         this.getApplicationDocuments()
  //       },
  //       error => console.log('error', error)
  //     );
  //   }
  // }
  
  closeDialog(): void {
    this.dialogRef.close();
  }

}
